import { useHistory } from 'react-router-dom'
import { Title } from '../../../components'
import {
    Container
} from './styles'

export default function (){
    const history = useHistory()
    const items = [
        {
            text: "Parâmetros Técnicos",
            url: "/pelve/parametrosTecnicos"
        },
        {
            text: "Posição do Paciente",
            url: "/pelve/posicaoPaciente"
        },
        {
            text: "Programação",
            url: "/pelve/linhasReferencia"
        },
        {
            text: "Reformatações Multiplanares",
            url: "/pelve/reformatacoesMultiplanares"
        },
        {
            text: "Protocolos de Pós-processamento",
            url: "/pelve/reformatacoes"
        },
        {
            text: "Back-Up",
            url: "/pelve/reformatacoes/BackUp"
        },
        {
            text: "Documentação",
            url: "/pelve/reformatacoes/Documentacao"
        },
    ]
    return (
        <Container>
            <div className="row">
                <div className="col">
                    <Title>Tomografia Computadorizada Multislice da Pelve com Contraste I.V.</Title>
                </div>
            </div>
            <div className="row justify-content-center">
                <div className="col-10">
                    {
                        items.map(item => (
                            <button
                                key={item.url}
                                className="btn btn-info btn-block my-4"
                                onClick={
                                    () => history.push(`/tronco${ item.url }`)
                                }
                            >{ item.text }</button>
                        ))
                    }
                </div>
            </div>
        </Container>
    )
}